import React from "react";
//#region types
import { TodoChipContainerProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { ButtonBase } from "@mui/material";
import TodoChip from "./chip";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { useTodoService } from "serviceHooks";

const TodoChipContainer: React.FC<TodoChipContainerProps> = (props) => {
  const todoService = useTodoService();
  const { todo } = props;

  const todoInfo = todoService.mapToChip(todo);

  return (
    <ButtonBase component="div" className={cssExports.todoChip}>
      <TodoChip todoInfo={todoInfo} />
    </ButtonBase>
  );
};

export default TodoChipContainer;
